import React, { useState } from 'react';
import { copyFor } from 'config';
import { Button, Text } from '@perch-labs/shrike';
import { SupportModal } from 'components/modals/support';
import { Card } from 'styles';

const getCopy = copyFor('modules.contactSupport');
type Props = {
  margin?: Margin;
  isWaitlist?: boolean;
};

export const ContactSupport = ({ margin, isWaitlist }: Props) => {
  const [showSupportModal, setShowSupportModal] = useState(false);
  return (
    <Card mobileVariant="flat" margin={margin}>
      {showSupportModal && (
        <SupportModal onClose={() => setShowSupportModal(false)} />
      )}
      <Card.Header>
        <Text tag="h2" textStyle="heading700" margin={{ bottom: '8px' }}>
          {getCopy('title')}
        </Text>
      </Card.Header>

      <Card.Content>
        <Text className="notranslate" opacity="medium">
          {getCopy('text')}
        </Text>
        <Button
          margin={
            isWaitlist ? { top: '24px' } : { top: '60px', bottom: '15px' }
          }
          backgroundless
          fullWidth
          onClick={() => setShowSupportModal(true)}
        >
          {getCopy('button')}
        </Button>
      </Card.Content>
    </Card>
  );
};
